module.exports = __webpack_public_path__ + "img/delete.0ae44a70.png";